import { Component, ElementRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, PopoverController, ModalController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { ProductosElaboradosProvider } from '../../providers/productos-elaborados/productos-elaborados'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,RUTA_MODO_DESCONECTADO, NUBE_AWS } from '../../config/url.servicio'
import { ElectronService } from 'ngx-electron';
import { UtilsProvider } from '../../providers/utils/utils'
import { ImprimirGlobalComponent } from '../imprimir-global/imprimir-global';
import { ProductosCamposAdicionalesComponent } from '../../components/productos-campos-adicionales/productos-campos-adicionales';
import { ProductosCamposAdicionalesCambiarValorImpuestosComponent } from '../../components/productos-campos-adicionales-cambiar-valor-impuestos/productos-campos-adicionales-cambiar-valor-impuestos';

@IonicPage()
@Component({
  selector: 'page-productos-elaborados',
  templateUrl: 'productos-elaborados.html',
  providers: [ AuthService,ElectronService ]
})
export class ProductosElaboradosPage {
  @ViewChild('fileInp') fileInput : ElementRef;
  @ViewChild('imagenProducto') imagenProducto: ElementRef;

  peticion: string = "productoselaborados";
  productos = []
  codigoProducto
  nombreProducto
  codigoBarra
  valorVenta
  tipoImpuesto
  valorImpuesto
  productosElaboradosId
  imagen
  typeImg
  imagenProd
  loader
  editarProducto
  allItems: any;
  buscar: any = "";
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  companiasId:any = null
  uuId
  controlaImpresorasEnRed: boolean = false;
  inputIP: string = ""
  isValidIP: boolean = true;
  nombreImpresora:string = ''
  ip:string = ''
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public storage:Storage,
              public servicio:ProductosElaboradosProvider,
              public alertControllers:AlertController,
              public loadingControllers:LoadingController ,
              public servicioCompania:CompaniasProvider,
              public auth: AuthService,
              public mensaje: UtilsProvider,
              private _electronService: ElectronService,
              private popoverCtrl: PopoverController,
              public modalControllers: ModalController
            ) {
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                    var valor = val['companiasId']
                    this.companiasId = valor
                    this.productos = []
                    let tmodo = MODO_DESCONECTADO
                    if(tmodo){
                      let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos-Elaborados',RUTA_MODO_DESCONECTADO)

                      if(resultado){
                        this.productos = JSON.parse(resultado)
                        this.allItems = JSON.parse(resultado)
                      }

                    }else{
                    this.cargarProductos()
                    this.limpiar()
                    }
                  }
                })

  }



  ionViewDidLoad() {
    console.log('ionViewDidLoad ProductosElaboradosPage');
  }
  ubicacion(queHago:string){

    switch (queHago) {
      case 'productoselaborados' : {

        break;
      }
    }
  }

  fileUpload(event) {
    var reader = new FileReader();

    reader.onload = (e) => {
      this.imagenProducto['src'] = e.target['result'];
      this.imagen = e.target['result'];
    };

    reader.readAsDataURL(event.srcElement.files[0]);
    this.typeImg = event.srcElement.files[0].type
    this.imagenProd = event.srcElement.files[0]
  }

  onClick() {
    this.fileInput.nativeElement.click();
  }

  guardar() {

    this.loader = this.loadingControllers.create({});
    this.loader.present();
    let datosProducto: any = {}
    if(MODO_DESCONECTADO){
       datosProducto = {
        codigoProducto: this.codigoProducto,
        nombreProducto: this.nombreProducto,
        imagen: this.imagenProd,
        valorVenta: this.valorVenta,
        tipoImpuesto: this.tipoImpuesto,
        valorImpuesto: this.valorImpuesto,
        uuId:this.uuId,
        codigoBarra: this.codigoBarra,
        productosElaboradosId:this.productosElaboradosId,
        nombreImpresora: this.nombreImpresora
      }
    }else{
       datosProducto = {
        codigoProducto: this.codigoProducto,
        nombreProducto: this.nombreProducto,
        imagen: this.imagenProd,
        valorVenta: this.valorVenta,
        tipoImpuesto: this.tipoImpuesto,
        valorImpuesto: this.valorImpuesto,
        codigoBarra: this.codigoBarra,
        nombreImpresora: this.nombreImpresora
      }
    }



    this.storage.get('companiasId').then((val) => {

      datosProducto['companiasId'] = val
      this.allItems = []
      if(MODO_DESCONECTADO){
        if(this.editarProducto){
          this.editarProducto = false;
          this.guardarProducto(datosProducto)
        } else {
          this.guardarProducto(datosProducto)
        }
    }else{
      if(this.editarProducto){
        this.editarProducto = false;
        this.editarProduct(datosProducto)
      } else {
        this.guardarProducto(datosProducto)
      }
    }
    });
  }

  editarProduct(datosProducto) {
    datosProducto['productosElaboradosId'] = this.productosElaboradosId
    if(NUBE_AWS) {
      if(this.typeImg == undefined || (this.typeImg = 'image/png' && this.imagen == '') ){
        let datos: any = {
          companiasId: datosProducto.companiasId,
          queHago: "A",
          nombreTabla: "productosElaborados",
          name: "dataDynamicCrud",
          productosElaboradosId: datosProducto.productosElaboradosId,
          codigoProductoElaborado: datosProducto.codigoProducto,
          nombreProductoElaborado: datosProducto.nombreProducto,
          imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          valorVenta: datosProducto.valorVenta,
          tipoImpuesto: datosProducto.tipoImpuesto,
          valorImpuesto: datosProducto.valorImpuesto,
          imagenLocal: 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          estado: 0,
          prioridad: 0,
          nombreImpresora: this.nombreImpresora
        }
        this.servicio.editar(datos, this.typeImg).subscribe((data: any)=> {
          this.mensaje.mensajeMuestro('Productos Elaborados','Registro actualizado con Éxito!','success')
          this.procesarResultado()
          this.typeImg
          this.imagenProd
        },(error) => {
          this.mensaje.mensajeMuestro('Productos Elaborados','No se pudo actualizar el productoElaborado, intente luego','error')
          this.procesarResultado()
      })
      } else {
        this.servicio.guardarImagen(datosProducto, this.typeImg).subscribe((data: any)=> {
          let datos: any = {
            companiasId: datosProducto.companiasId,
            queHago: "A",
            nombreTabla: "productosElaborados",
            name: "dataDynamicCrud",
            productosElaboradosId: datosProducto.productosElaboradosId,
            codigoProductoElaborado: datosProducto.codigoProducto,
            nombreProductoElaborado: datosProducto.nombreProducto,
            imagen:data.link,
            valorVenta: datosProducto.valorVenta,
            tipoImpuesto: datosProducto.tipoImpuesto,
            valorImpuesto: datosProducto.valorImpuesto,
            imagenLocal: data.link,
            estado: 0,
            prioridad: 0,
            nombreImpresora: this.nombreImpresora
          }
          this.servicio.editar(datos, this.typeImg).subscribe((data: any)=> {
            this.mensaje.mensajeMuestro('Productos Elaborados','Registro actualizado con Éxito!','success')
            this.procesarResultado()
            this.typeImg
            this.imagenProd
          },(error) => {
            this.mensaje.mensajeMuestro('Productos Elaborados','No se pudo actualizar el productoElaborado, intente luego','error')
            this.procesarResultado()
        })
        }, (error) => {
          this.mensaje.mensajeMuestro('Productos Elaborados','No se pudo actualizar el productoElaborado, intente luego','error')
          this.procesarResultado()
        })
      }

    } else {
      this.servicio.editar(datosProducto, this.typeImg)
      .subscribe(
        res => {
          this.mensaje.mensajeMuestro('Productos Elaborados','Registro actualizado con Éxito!','success')
          this.procesarResultado()
        },
        err => this.mensaje.mensajeMuestro('Productos Elaborados','No se pudo actualizar el productoElaborado, intente luego','error')
      )
   }
  }

  guardarProducto(datosProducto){
    this.storage.get('companiasId').then((val) => {

      let datosProducto: any = {}
      if(MODO_DESCONECTADO){
        datosProducto = {
          codigoProductoElaborado: this.codigoProducto,
          nombreProductoElaborado: this.nombreProducto,
          imagen: this.imagenProd,
          valorVenta: this.valorVenta,
          tipoImpuesto: this.tipoImpuesto,
          valorImpuesto: this.valorImpuesto,
          productosElaboradosId: this.productosElaboradosId == undefined ? "0" : this.productosElaboradosId,
          uuId:this.uuId,
          codigoBarra: this.codigoBarra,
          nombreImpresora: this.nombreImpresora
        }
      }else{
        datosProducto = {
          codigoProducto: this.codigoProducto,
          nombreProducto: this.nombreProducto,
          imagen: this.imagenProd,
          valorVenta: this.valorVenta,
          tipoImpuesto: this.tipoImpuesto,
          valorImpuesto: this.valorImpuesto,
          codigoBarra:this.codigoBarra,
          nombreImpresora: this.nombreImpresora
        }
      }

      datosProducto['companiasId'] = val

      if(MODO_DESCONECTADO){
        let resultado = this._electronService.ipcRenderer.sendSync('guardar-mododesconectado-todos',datosProducto,'c:\\bd','productosElaborados')
           this.limpiar()
           this.loader.dismiss()


           let resultadob = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos-Elaborados',RUTA_MODO_DESCONECTADO)

            if(resultadob){
              this.productos = JSON.parse(resultadob)
              this.allItems = JSON.parse(resultadob)
            }

      }else{
        if(NUBE_AWS) {
          if(this.typeImg == undefined || (this.typeImg = 'image/png' && this.imagen == '') ){
            let datos: any = {
              companiasId: datosProducto.companiasId,
              queHago: "I",
              nombreTabla: "productosElaborados",
              name: "dataDynamicCrud",
              productosElaboradosId: datosProducto.productosElaboradosId == undefined ? "0" : datosProducto.productosElaboradosId,
              codigoProductoElaborado: datosProducto.codigoProducto,
              nombreProductoElaborado: datosProducto.nombreProducto,
              imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
              valorVenta: datosProducto.valorVenta,
              tipoImpuesto: datosProducto.tipoImpuesto,
              valorImpuesto: datosProducto.valorImpuesto,
              imagenLocal: 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
              estado: 0,
              prioridad: 0,
              nombreImpresora: this.nombreImpresora
            }
            this.servicio.guardar(datos, this.typeImg).subscribe((data: any)=> {
              this.mensaje.mensajeMuestro('Productos Elaborados','Registro almacenado con Éxito!','success')
              this.procesarResultado()
              this.typeImg
              this.imagenProd
            },(error) => {
              this.mensaje.mensajeMuestro('Productos Elaborados','No se pudo guardar el productoElaborado, intente luego','error')
              this.procesarResultado()
          })
          }else {
            this.servicio.guardarImagen(datosProducto, this.typeImg).subscribe((data: any)=> {
              let datos: any = {
                companiasId: datosProducto.companiasId,
                queHago: "I",
                nombreTabla: "productosElaborados",
                name: "dataDynamicCrud",
                productosElaboradosId: datosProducto.productosElaboradosId == undefined ? "0" : datosProducto.productosElaboradosId,
                codigoProductoElaborado: datosProducto.codigoProducto,
                nombreProductoElaborado: datosProducto.nombreProducto,
                imagen:data.link,
                valorVenta: datosProducto.valorVenta,
                tipoImpuesto: datosProducto.tipoImpuesto,
                valorImpuesto: datosProducto.valorImpuesto,
                imagenLocal: data.link,
                estado: 0,
                prioridad: 0,
                nombreImpresora: this.nombreImpresora
              }
              this.servicio.guardar(datos, this.typeImg).subscribe((data: any)=> {
                this.mensaje.mensajeMuestro('Productos Elaborados','Registro almacenado con Éxito!','success')
                this.procesarResultado()
                this.typeImg
                this.imagenProd
              },(error) => {
                this.mensaje.mensajeMuestro('Productos Elaborados','No se pudo guardar el productoElaborado, intente luego','error')
                this.procesarResultado()
            })
            }, (error) => {
              this.mensaje.mensajeMuestro('Productos Elaborados','No se pudo guardar el productoElaborado, intente luego','error')
              this.procesarResultado()
            })
          }

        } else {
          this.servicio.guardar(datosProducto, this.typeImg)
          .subscribe(
            res => {
              this.mensaje.mensajeMuestro('Productos Elaborados','Registro almacenado con Éxito!','success')
              this.procesarResultado()
            },
            err => this.mensaje.mensajeMuestro('Productos Elaborados','No se pudo guardar el productoElaborado, intente luego','error')
          )
       }
      }
    });
  }

  procesarResultado() {
    this.limpiar()
    this.loader.dismiss()
    this.cargarProductos()
  }


  cargarProductos() {
    this.productos = []
    this.servicio.buscarProductoElaboradosCompania(this.companiasId)
    .subscribe(
      res => {
        this.productos = !NUBE_AWS ? res[0] : JSON.parse(res['_body']).data[0]
        this.allItems = !NUBE_AWS ? res[0] : JSON.parse(res['_body']).data[0]
      },
      err => {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: 'No se pudieron listar los productosElaborados, intente luego',
          buttons: ['Cerrar']
        });
        alert.present();
      }
    )
    this.servicio.buscarParametroGeneralIp(this.companiasId)
    .subscribe(
      res => {
        let responseControlaImpresora = !NUBE_AWS ? res[0] : JSON.parse(res['_body']).data[0]
        if(responseControlaImpresora.length > 0) {
          this.controlaImpresorasEnRed  = responseControlaImpresora[0].controlaImpresorasEnRed == 'S' ? true : false;
          this.ip = responseControlaImpresora[0].ip;
        }
      },
      err => {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: 'No se sabe si contrala impresara en red, intente luego',
          buttons: ['Cerrar']
        });
        this.controlaImpresorasEnRed = false
        alert.present();
      }
    )
  }

  mostrarMensajeDeError(mensaje) {
    let alert = this.alertControllers.create({
      title: 'Error',
      subTitle: mensaje,
      buttons: ['Cerrar']
    });
    alert.present();

    this.loader.dismiss()
  }


  limpiar() {
    this.codigoProducto = ""
    this.nombreProducto = ""
    this.imagenProd = ""
    this.valorVenta = 0
    this.tipoImpuesto = "I"
    this.valorImpuesto = 0
    this.imagen = ""
    this.allItems = []
    this.productosElaboradosId = 0
    this.uuId = undefined
    this.codigoBarra = ""
    this.nombreImpresora = ""
  }

  editar(item){
    this.codigoProducto = item.codigoProductoElaborado
    this.nombreProducto = item.nombreProductoElaborado
    this.valorVenta = item.valorVenta
    this.tipoImpuesto = item.tipoImpuesto
    this.valorImpuesto = item.valorImpuesto
    this.imagen = item.imagen
    this.productosElaboradosId = item.productosElaboradosId
    this.editarProducto = true
    this.buscar =""
    this.allItems = []
    this.productosElaboradosId = item.productosElaboradosId
    this.uuId = item.uuid
    this.codigoBarra = item.codigoBarra
    this.nombreImpresora = item.nombreImpresora
  }

  eliminar(item) {
    this.mensaje.mensajeConfirmacionDos('Productos Elaborados','¿Desea eliminar el registro?','question','Si','No')
      .then((laRespuesta: boolean) =>{
        if (laRespuesta){
          this.buscar =""
          this.loader = this.loadingControllers.create({});
          this.loader.present();

          if(MODO_DESCONECTADO){
            let resultadoNuevo = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos-Elaborados-eliminar',item)
            if(resultadoNuevo){

              this.limpiar()
              this.loader.dismiss()
              this.productos = []
              this.allItems = []

              let valores = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos-Elaborados')
              if(valores){

                this.productos = JSON.parse(valores)
                this.allItems = JSON.parse(valores)
              }

           }
          }else{
            this.servicio.eliminar(item)
            .subscribe(
              res => {
                this.mensaje.mensajeMuestro('Productos Elaborados','Registro eliminado con Éxito!','success')
                this.procesarResultado()
              },
              err => this.mensaje.mensajeMuestro('Productos Elaborados','No se pudo eliminar el producto, intente luego','error')
            )
          }
        }
        else {
          this.mensaje.mensajeMuestro('Productos Elaborados','No se eliminó el registro','success')
        }
      })
  }


  getItems(event: any): void {
    if(!this.allItems){
      let valores = this.productos
      this.allItems = valores;
    }
      this.productos = this.allItems.filter((item) => {
        return item.nombreProductoElaborado.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
      });
  }

onEvent(event: string, item: any){
  if (event === 'onTextChange') {

  let valor = this.getItems(this.buscar);
  if(valor){
      item = valor
  }
  }
}

cerrarSession(){
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}

imprimirGlobal(devolverNombreImpresora:string) {
  let popover = this.popoverCtrl.create(ImprimirGlobalComponent, { text: '',
    queHago:devolverNombreImpresora,
    cantidadImpresionesEnCaja: '1',
    ip:this.ip
  });
  popover.present({
    ev: ''
  });
  popover.onDidDismiss((data) => {
    if (data) {
      this.nombreImpresora = data
    }
  });
}

validateIP() {
  const ipPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  this.isValidIP = ipPattern.test(this.nombreImpresora);
  if(!this.isValidIP) {
    this.mensaje.mensajeMuestro('Productos Elaborados','Ip no valida','warning')
    this.nombreImpresora = ''
  }
}

camposAdicionales() {
  if(this.productosElaboradosId == 0 || this.productosElaboradosId == undefined) {
    this.mensaje.mensajeMuestro('Productos elaborados','Para gestionar campos adicionales debe estar actualizando un producto elaborado','warning')
    return
  }
  let modal = this.modalControllers.create(ProductosCamposAdicionalesComponent, { productosId: this.productosElaboradosId, tipo: 'E' , nombreProducto:this.nombreProducto}, {
      cssClass: 'fullscreen-modal',
      enableBackdropDismiss: true
  })
  modal.present();

  modal.onDidDismiss(data => {
    if (data) {
    }
  })
  }

  actualizarImpuestos() {
    if(this.productosElaboradosId == 0 || this.productosElaboradosId == undefined) {
      this.mensaje.mensajeMuestro('Productos elaborados','Para actualizar impuestos debe estar actualizando un producto','warning')
      return
    }
    let modal = this.modalControllers.create(ProductosCamposAdicionalesCambiarValorImpuestosComponent, { productosId: this.productosElaboradosId, tipo: 'E' , nombreProducto:this.nombreProducto}, {
        cssClass: 'fullscreen-modal',
        enableBackdropDismiss: true
    })
    modal.present();

    modal.onDidDismiss(data => {
      if (data) {
      }
    })
    }

}



// WEBPACK FOOTER //
// ./src/pages/productos-elaborados/productos-elaborados.ts